module.exports = __webpack_public_path__ + "static/img/gogo-people.481a0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gogo-people.png
// module id = 653
// module chunks = 1